import { getContact, getSocials } from '@/data/site';
import { useLiveTick } from '@/lib/liveContent';
import { CONTACT_FAQS, CONTACT_SEO } from '@/data/contact';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { ContactHero } from '@/components/site/contact/ContactHero';
import { ConnectOptions } from '@/components/site/contact/ConnectOptions';
import { ContactEnquiryForm } from '@/components/site/contact/ContactEnquiryForm';
import { BookingJourney } from '@/components/site/contact/BookingJourney';
import { WhatHappensNext } from '@/components/site/contact/WhatHappensNext';
import { ContactDetails } from '@/components/site/contact/ContactDetails';
import { ContactFaq } from '@/components/site/contact/ContactFaq';

export default function ContactPage() {
  useLiveTick();
  const CONTACT = getContact();
  const SOCIALS = getSocials();
  const origin = SITE_ORIGIN;

  useSeo({
    title: CONTACT_SEO.title,
    description: CONTACT_SEO.description,
    canonical: `${origin}/contact`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'ContactPage',
          name: CONTACT_SEO.title,
          description: CONTACT_SEO.description,
          url: `${origin}/contact`,
        },
        {
          '@type': 'Organization',
          name: 'Amden Group',
          url: origin,
          telephone: CONTACT.phoneHref.replace('tel:', ''),
          email: CONTACT.email,
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Unit 39, Kells Business Park',
            addressLocality: 'Kells',
            addressRegion: 'Co. Meath',
            postalCode: 'A82 PA44',
            addressCountry: 'IE',
          },
          sameAs: SOCIALS.map((s) => s.href),
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: `${origin}/` },
            { '@type': 'ListItem', position: 2, name: 'Contact', item: `${origin}/contact` },
          ],
        },
        {
          // Only the FAQs visibly displayed on this page.
          '@type': 'FAQPage',
          mainEntity: CONTACT_FAQS.map((f) => ({
            '@type': 'Question',
            name: f.question,
            acceptedAnswer: { '@type': 'Answer', text: f.answer },
          })),
        },
      ],
    },
  });

  return (
    <>
      <ContactHero />
      <ConnectOptions />
      <ContactEnquiryForm />
      <BookingJourney />
      <WhatHappensNext />
      <ContactDetails />
      <ContactFaq />
    </>
  );
}
